import { render, staticRenderFns } from "./BackgroundSample.vue?vue&type=template&id=70a5b364&"
import script from "./BackgroundSample.vue?vue&type=script&lang=js&"
export * from "./BackgroundSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports